export default __webpack_public_path__ + "static/media/icon_facility_rest.2468acff.svg";